module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_bank_active.0d923803.svg";